import { gql } from '@apollo/client';
import { type Relationship } from 'types/Relationship';
import { RELATIONSHIP_FRAGMENT } from './RelationshipFragments';

export const ACCEPT_RELATIONSHIP_MUTATION = gql`
  mutation acceptRelationshipMutation($uuid: String!) {
    acceptRelationship(uuid: $uuid) {
      errorReason
      relationship {
        ...relationshipFields
      }
    }
  }
  ${RELATIONSHIP_FRAGMENT}
`;

export enum AcceptRelationshipError {
  ALREADY_ACCEPTED = 'ALREADY_ACCEPTED',
  NOT_FOUND = 'NOT_FOUND',
  OTHER = 'OTHER',
}

export type AcceptRelationshipOutput = {
  acceptRelationship: {
    errorReason?: AcceptRelationshipError;
    relationship?: Relationship;
  };
};

export const ADD_RELATIONSHIP_MUTATION = gql`
  mutation addRelationshipMutation($input: AddRelationshipInput!) {
    addRelationship(input: $input) {
      errorReason
      relationship {
        ...relationshipFields
      }
    }
  }
  ${RELATIONSHIP_FRAGMENT}
`;

export enum AddRelationshipError {
  ALREADY_EXISTS = 'ALREADY_EXISTS',
  MAIN_USER_NOT_FOUND = 'MAIN_USER_NOT_FOUND',
  MINIMAL_VERSION_NOT_SATISFIED = 'MINIMAL_VERSION_NOT_SATISFIED',
  NOTIFICATION_ERROR = 'NOTIFICATION_ERROR',
  NO_CHANNEL_ON_MAIN_USER = 'NO_CHANNEL_ON_MAIN_USER',
  USER_ALREADY_LINKED_TO_A_WEB_USER = 'USER_ALREADY_LINKED_TO_A_WEB_USER',
  USER_NOT_FOUND = 'USER_NOT_FOUND',
  USER_WITHOUT_FAMILY_ACCESS = 'USER_WITHOUT_FAMILY_ACCESS',
  WEB_USER_ALREADY_LINKED_TO_CHANNEL = 'WEB_USER_ALREADY_LINKED_TO_CHANNEL',
}

export type AddRelationshipOutput = {
  addRelationship: {
    errorReason?: AddRelationshipError;
    relationship?: Relationship;
  };
};
